<template>
  <section class="h-full bg-documentGray">
    <div class="sm_star">
      <header class="sm_header">
        <button
          type="button"
          class="close_btn"
          tabindex="0"
          @click="back()"
        ></button>
        <input
          type="text"
          id="searchInput"
          :placeholder="$t('S20056')"
          ref="searchInputRef"
          class="search_form"
          @input="handleText"
          :value="searchText"
          autofocus
          @keyup.enter="search()"
        />
        <div
          v-if="searchText && searchText.length > 0"
          class="search-close-btn"
        >
          <img
            class="search-close-btn__image"
            src="@/images/close_search.png"
            alt="close_search"
            @click="removeSearchText"
          />
        </div>
        <button type="button" class="search_btn" @click="search()">검색</button>
      </header>

      <main class="mdc-top-app-bar--fixed-adjust pdl-16 pdr-16 pdb-16">
        <!-- 검색 데이터 있을 경우 -->
        <div v-if="searchResultList && searchResultList.length > 0">
          <!-- 카테고리 선택 -->
          <div class="mgt-16" v-if="categoryList.length > 0">
            <div class="search-title">{{ $t("S20059") }}</div>
            <div class="d-flex wrap-vertical">
              <div
                class="item-box item-text d-flex align-items-center"
                :class="
                  selectedCategory === null
                    ? 'item-box__selected item-text__selected'
                    : ''
                "
                @click="handleCategory()"
              >
                <span
                  v-if="selectedCategory === null"
                  class="material-icons check-icon"
                  >check</span
                >
                {{ $t("S20060") }}
              </div>
              <div
                class="item-box d-flex align-items-center"
                :class="
                  selectedCategory && selectedCategory === category.id
                    ? 'item-box__selected item-text__selected'
                    : ''
                "
                v-for="(category, index) in categoryList"
                :key="index"
                @click="handleCategory(category)"
              >
                <span
                  v-if="selectedCategory && selectedCategory === category.id"
                  class="material-icons check-icon"
                  >check</span
                >
                <div
                  class="item-text"
                  :class="{
                    'item-text__selected':
                      selectedCategory && selectedCategory === category.id,
                  }"
                >
                  {{ category.name }}
                </div>
              </div>
            </div>
          </div>

          <div class="sort-wrapper d-flex mgt-24">
            <select class="select-wrapper" @change="handleSortOption">
              <option v-for="(sort, i) in sortList" :key="i" :value="sort.id">
                {{ sort.name }}
              </option>
            </select>
            <span class="material-icons select-wrapper__color"
              >arrow_drop_down</span
            >
          </div>

          <div
            v-for="(data, index) in searchResultList"
            :key="index"
            class="search-item-box"
            @click="moveToDetail(data)"
          >
            <div
              v-if="data.thumbnail && data.thumbnail.length > 0"
              class="search-item-image"
              :style="`background-image: url(${data.thumbnail})`"
            />
            <div class="search-item-info">
              <div>
                <div class="search-item-text__category">
                  {{ data.category.text }}
                </div>
                <div class="search-item-text__title">{{ data.name }}</div>
              </div>
              <div class="search-item-text__teacher" style="">
                <span class="search-item-text">by </span>
                {{ data.teacher && data.teacher.name && data.teacher.name.fullName ? data.teacher.name.fullName : "" }}
              </div>
            </div>
          </div>

          <infinite-loading
            @infinite="moreData"
            :identifier="infiniteId"
            spinner="spiral"
            ref="infiniteLoading"
          >
            <div slot="no-more" class="mgt-16"></div>
            <div slot="no-results" class="mgt-16"></div>
          </infinite-loading>
        </div>

        <div v-else-if="searchResultList && searchResultList.length === 0">
          <!-- 카테고리 선택 -->
          <div class="mgt-16" v-if="categoryList.length > 0">
            <div class="search-title">{{ $t("S20059") }}</div>
            <div class="d-flex wrap-vertical">
              <div
                class="item-box item-text d-flex align-items-center"
                :class="
                  selectedCategory === null
                    ? 'item-box__selected item-text__selected'
                    : ''
                "
                @click="handleCategory()"
              >
                <span
                  v-if="selectedCategory === null"
                  class="material-icons check-icon"
                  >check</span
                >
                {{ $t("S20060") }}
              </div>
              <div
                class="item-box d-flex align-items-center"
                :class="
                  selectedCategory && selectedCategory === category.id
                    ? 'item-box__selected item-text__selected'
                    : ''
                "
                v-for="(category, index) in categoryList"
                :key="index"
                @click="handleCategory(category)"
              >
                <span
                  v-if="selectedCategory && selectedCategory === category.id"
                  class="material-icons check-icon"
                  >check</span
                >
                <div
                  class="item-text"
                  :class="{
                    'item-text__selected':
                      selectedCategory && selectedCategory === category.id,
                  }"
                >
                  {{ category.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="search-title search-title-text__wrapper">
            <div class="search-title-text__title">{{ $t("S20064") }}</div>
            <div class="search-title-text__sub-title">{{ $t("S20067") }}</div>
          </div>
        </div>

        <!-- 검색 데이터 없을 경우 -->
        <div v-else>
          <!-- 추천 검색어 -->
          <div class="mgt-16 mgb-32" v-if="tagList.length > 0">
            <div class="search-title">{{ $t("S20057") }}</div>
            <div class="d-flex tag-wrapper">
              <div
                class="tag-box"
                v-for="(tag, index) in tagList"
                :key="index"
                @click="clickSearch(tag.name)"
              >
                #{{ tag.name }}
              </div>
            </div>
          </div>

          <!-- 최근 검색 -->

          <div
            v-if="recentSearchList && recentSearchList.length > 0"
            class="pdb-34"
          >
            <div class="search-title">{{ $t("S20058") }}</div>
            <div class="mgt-16" />
            <div
              v-for="recentData in recentSearchList"
              :key="recentData.id"
              class="search-text-wrapper"
              @click="clickSearch(recentData.searchText)"
            >
              <div class="search-icon-head">
                <span class="material-icons search-item-text">history</span>
              </div>
              <div class="search-text">{{ recentData.searchText }}</div>
              <div
                class="search-icon-tail"
                @click="(e) => deleteRecentSearchList(e, recentData)"
              >
                <span class="material-icons search-item-text">close</span>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </section>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import mainApi from "@/api/mainApi";
import searchApi from "@/api/searchApi";
import { topAppBarMixin } from "@/mixins/topAppBar";

export default {
  name: "Search",

  components: {
    InfiniteLoading,
  },

  mixins: [topAppBarMixin],

  watch: {
    searchText(cur) {
      if (cur === "") {
        this.searchResultList = null;
        this.totalPage = 1;
        this.currentPage = 1;
        this.getRecentSearchList();
        this.infiniteId = +new Date();
        this.selectedCategory = null;
      }
    },
  },

  data() {
    return {
      // 검색어
      searchText: "",

      // 카테고리
      categoryList: [],
      selectedCategory: null,

      // 추천 검색어
      tagList: [],
      selectedTag: null,

      // 최근 검색어
      recentSearchList: null,

      // 검색 정렬 조건
      sortCondition: "id,desc",
      sortList: [
        { name: this.$t("S20062"), id: "id,desc" },
        { name: this.$t("S20063"), id: "degree.learnerCount,desc" },
      ],

      searchResultList: null,
      totalPage: 1,
      currentPage: 1,
      infiniteId: +new Date(),
      moreLoading: false,
    };
  },

  mounted() {
    if (this.$route.query.search) {
      this.searchText = this.$route.query.search.search;
      this.sortCondition = this.$route.query.search.sort;
      this.search("category");
    }

    this.fetchData();
    this.getRecentSearchList();
    this.focusSearchInput();
  },

  methods: {
    async fetchData() {
      try {
        const [categoryListResult, tagListResult] = await Promise.all([
          mainApi.fetchCategoryList(),
          searchApi.getRecommendTags({ itemCount: 10 }),
        ]);

        if (categoryListResult && categoryListResult.data.data) {
          this.categoryList = categoryListResult.data.data;
        }

        if (tagListResult && tagListResult.data.data) {
          this.tagList = tagListResult.data.data;
        }
      } catch (mainError) {
        console.log("Main Error : ", mainError);
      }
    },

    getRecentSearchList() {
      const localRecentSearchList = JSON.parse(
        localStorage.getItem("recentSearchList")
      );
      if (localRecentSearchList) {
        this.recentSearchList = [...localRecentSearchList].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      }
    },

    handleCategory(data) {
      this.selectedCategory = data && data.id ? data.id : null;
      this.initData();
      this.search("category");
    },

    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.infiniteId += 1;
    },

    setSearchParams() {
      let params = {
        size: 5,
        page: this.currentPage,
        sort: this.sortCondition,
        search: this.searchText,
        category: this.selectedCategory,
        tags: this.selectedTag,
      };
      return params;
    },

    handleText(evt) {
      this.searchText = evt.target.value;
    },

    async search(categoryText) {
      this.$showLoading();
      if (this.searchText === "") {
        this.$hideLoading();
        return (this.searchResultList = null);
      }

      const params = this.setSearchParams();
      try {
        const searchResult = await searchApi.search(params);
        console.log("*** SEARCH RESULT : ", searchResult);
        if (searchResult && searchResult.data.data) {
          this.searchResultList = searchResult.data.data.content;
          this.totalPage = searchResult.data.data.totalPages;
          if (categoryText !== "category") {
            this.addRecentSearchList();
          }
        }
      } catch (error) {
        console.log("SEARCH ERROR : ", error);
      } finally {
        this.$hideLoading();
      }
    },

    addRecentSearchList() {
      if (
        this.recentSearchList &&
        this.recentSearchList.length > 0 &&
        this.searchText === this.recentSearchList[0].searchText
      ) {
        return;
      }
      const addSearchData = {
        searchText: this.searchText,
        createdAt: new Date(),
        id: Math.floor(Math.random() * 900000) + 100000,
      };

      if (!this.recentSearchList) {
        this.recentSearchList = [addSearchData];
      } else if (this.recentSearchList.length === 10) {
        this.recentSearchList.pop();
        this.recentSearchList.push(addSearchData);
      } else {
        this.recentSearchList.push(addSearchData);
      }

      localStorage.setItem(
        "recentSearchList",
        JSON.stringify(this.recentSearchList)
      );
    },

    deleteRecentSearchList(e, data) {
      e.stopPropagation();
      const filterRecentSearchList = this.recentSearchList.filter(
        (item) => item.id !== data.id
      );
      localStorage.setItem(
        "recentSearchList",
        JSON.stringify(filterRecentSearchList)
      );
      this.getRecentSearchList();
      this.focusSearchInput();
    },

    back() {
      this.$router.push({
        name: "Main",
      });
    },

    async moreData($state) {
      if (this.moreLoading) {
        return;
      }

      this.moreLoading = true;
      this.currentPage += 1;
      this.infiniteId += 1;
      const params = this.setSearchParams();
      try {
        const searchResult = await searchApi.search(params);
        if (searchResult && searchResult.data.data) {
          this.searchResultList = [
            ...this.searchResultList,
            ...searchResult.data.data.content,
          ];
        }

        if (searchResult.data.data.content.length > 0) {
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (error) {
        console.log("MORE SEARCH ERROR : ", error);
      }

      this.moreLoading = false;
    },

    handleSortOption(e) {
      this.sortCondition = e.target.value;
      this.initData();
      this.search();
    },

    clickSearch(word) {
      this.searchText += word;
      this.currentPage = 1;
      this.search();
    },

    moveToDetail(data) {
      const params = this.setSearchParams();
      this.$router.push({
        path: `learn/${data.learnerId}`,
        query: {
          come: "SEARCH",
          search: params,
        },
      });
    },

    removeSearchText() {
      this.searchText = "";
      this.focusSearchInput();
    },

    focusSearchInput() {
      this.$refs.searchInputRef.focus();
    },
  },
};
</script>

<style>
.wrap-vertical {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow: auto;
  white-space: nowrap;
  margin-top: 16px;
}
.wrap-vetical::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.item-box {
  border: 1px solid #acb4be;
  border-radius: 14px;
  margin-right: 8px;
  padding: 6px 10px;
}
.item-box__selected {
  background: #2d6dcc;
  border: 1px solid #2d6dcc !important;
  background-color: #e0e8f4;
}
.tag-wrapper {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.search-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #212121;
}
.item-text {
  color: #acb4be;
  font-size: 12px;
}
.item-text__selected {
  color: #2d6dcc;
}
.tag-box {
  border: 1px solid #2d6dcc;
  border-radius: 14px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 18px;
  color: #2d6dcc;
}
.more-btn {
  border-radius: 4px;
  background: #a3b2c4;
  color: white;
  font-size: 12px;
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 10px 27px;
  margin-bottom: 20px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
}
.search-item-box {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
  height: 110px;
  border-radius: 8px;
  background: #ffffff;
  margin-bottom: 16px;
  display: flex;
}
.search-item-image {
  min-width: 110px;
  width: 110px;
  background-size: cover;
  background-size: contain;
  background-position: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.search-item-info {
  padding: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.search-item-text__category {
  font-size: 12px;
  font-weight: 400;
  color: #acb4be;
}
.search-item-text__title {
  font-size: 14px;
  font-weight: 500;
  color: #505050;
  line-height: 16px;
  margin-bottom: 10px;

  display: -webkit-box;
  -webkit-line-clamp: 2; /* 표시할 줄 수 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-item-text__teacher {
  font-size: 12px;
  font-weight: 400;
  color: #505050;
}
.search-item-text {
  color: #acb4be;
}
.sort-wrapper {
  margin-bottom: 12px;
}
.select-wrapper {
  border: none;
  background: transparent;
  display: block;
  margin-left: auto;
  color: #818181;
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-align: right;
}
.select-wrapper__color {
  color: #818181;
}
select::-ms-expand {
  display: none;
}
.search-icon-tail {
  margin-left: auto;
}
.search-text {
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  margin-left: 8px;
  color: #212121;
}
.search-text-wrapper {
  display: flex;
  padding: 13px 0px;
}
.check-icon {
  font-size: 14px !important;
  margin-right: 2px;
}
.search-title-text__wrapper {
  text-align: center;
  margin-top: 30px;
}
.search-title-text__title {
  color: #212121;
  font-size: 16px;
}
.search-title-text__sub-title {
  color: #818181;
  font-size: 14px;
  margin-top: 8px;
}
.search-close-btn {
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 55px;
  display: flex;
  align-content: center;
  justify-content: center;
}
.search-close-btn__image {
  width: 20px;
  aspect-ratio: 1/1;
  object-fit: contain;
  align-self: center;
}
</style>